<template>
  <div class="win">
    <h1>
      <span><span>{{$t('integration.real_time_situation_of_monitoring_points')}}</span> - {{time}}</span>
      <span><i class="el-icon-refresh icon" @click="handleRefresh"></i></span>
    </h1>
    <RealTimeSituation ref="realTimeSituation"></RealTimeSituation>

    <ProbeDetail></ProbeDetail>
  </div>
</template>

<script>
import RealTimeSituation from '../component/DisplayArea/RealTimeSituation.vue'

import ProbeDetail from '@/components/dialog/probeDetail/ProbeDetail.vue'
export default {
  methods: {
    handleRefresh () {
      this.$refs.realTimeSituation.getPointsDetail()
    }
  },
  data () {
    return {
      time: null,
      timer: null,
      sensorDetailShow: false,
      gatewayDetailShow: false,
      displayDetailShow: false,
      relayDetailShow: false
    }
  },
  components: {
    RealTimeSituation,
    ProbeDetail
  },
  mounted () {
    this.time = this.$timetransition(new Date().getTime())

    this.timer = setInterval(() => {
      this.time = this.$timetransition(new Date().getTime())
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.time)
  }
}
</script>

<style lang="scss" scoped>
.win{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
    h1 {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        border-bottom: 1px solid #ccc;
        padding-bottom: 15px;
        margin-bottom: 15px;
        .icon {
          position: absolute;
          top: 15px;
          right: 10px;
          font-size: 22px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
              color: red;
          }
      }
    }

}

</style>

</style>
